define('presentation/settings/liveReceptionistScripts/facades/associateLiveReceptionistScriptFacade',[
    'externalDependencies/clientWebSocket',
], function () {

    const liveReceptionistScriptSocket = require('externalDependencies/clientWebSocket').forApplication("liveReceptionistScript");
    let _promiseFactory = null;

    const _associateLiveReceptionistScript = (portalScriptId, type) => {
        const parameters = {
            liveReceptionistPortalScriptId: portalScriptId,
            type: parseInt(type)
        };
        return _promiseFactory.defer((promise) => {
            liveReceptionistScriptSocket.send("associateLiveReceptionistScript", parameters, (response) => {
                promise.resolve(response);
            });
        });
    };

    const _init = (promiseFactory) => {
        _promiseFactory = promiseFactory;
    };

    return function () {
        const self = this;
        self.init = _init;
        self.associateLiveReceptionistScript = _associateLiveReceptionistScript;
    };
});

